import { render } from "./BackgroundVideo.vue?vue&type=template&id=cc515a24&scoped=true"
const script = {}

import "./BackgroundVideo.vue?vue&type=style&index=0&id=cc515a24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc515a24"]])

export default __exports__